// extracted by mini-css-extract-plugin
export var askAiIcon = "_r4-9";
export var container = "_r4-0";
export var groupSeparator = "_r4-a";
export var highlight = "_r4-4";
export var resultIcon = "_r4-5";
export var resultItem = "_r4-7";
export var resultSubtitle = "_r4-3";
export var resultTitle = "_r4-2";
export var resultsList = "_r4-1";
export var searchGroup = "_r4-6";
export var selected = "_r4-8";